<template>
  <div class="product">
    <!--添加产品分类-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">
        添加分类
      </el-button>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="mini" :data="tableData" row-key="id" :default-expand-all="false" border
                  :tree-props="{children: 'children'}"
                  style="width: 100%" v-loading="loading">
          <el-table-column prop="typeName" label="分类名称" min-width="180"></el-table-column>
          <el-table-column prop="orderNum" label="分类排序" align="center" width="90px"></el-table-column>
          <el-table-column prop="createTime" label="添加时间" align="center" width="175px"></el-table-column>
          <el-table-column header-align="center" align="left" label="操作" width="190">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑
              </el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">
                删除
              </el-button>
              <el-button @click="addChildClick(scope.row)" type="text" size="small" v-if="scope.row.level < 3">新增子分类
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="40%">
      <el-form size="small" :model="editFormData" :rules="formRules" ref="form" label-width="100px">
        <el-form-item label="所属分类" prop="parentId">
          <treeselect style="width: 70%" v-model="editFormData.parentId" :options="getTreeOptions"
                      :normalizer="normalizer"
                      placeholder="请选择上级分类"/>
        </el-form-item>
        <el-form-item label="分类名称" prop="typeName">
          <el-input v-model="editFormData.typeName" autocomplete="off" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="分类排序" prop="orderNum">
          <el-input v-model.number="editFormData.orderNum" style="width: 70%" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CropSolutionApi from '@/api/cropsolution.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'list',
  components: {
    Treeselect
  },
  data () {
    return {
      loading: false,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      editFormData: {
        typeName: '',
        parentId: 0,
        orderNum: 1,
        remark: ''
      },
      formRules: {
        parentId: [{
          required: true,
          message: '请选择上级分类',
          trigger: 'change'
        }],
        typeName: [{
          required: true,
          message: '请输入分类名称',
          trigger: 'blur'
        }],
        orderNum: [{
          required: true,
          message: '分类排序不能为空'
        }, {
          type: 'number',
          message: '分类排序必须为数字'
        }]
      },
    }
  },
  computed: {
    getTreeOptions () {
      let treeOptions = [{
        id: '0',
        typeName: '顶级分类'
      }]
      treeOptions = treeOptions.concat(this.tableData)
      return treeOptions
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getSolutionTypeList()
    },
    normalizer (node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.typeName,
        children: node.children
      }
    },
    getSolutionTypeList () {
      let self = this
      CropSolutionApi.getCropSolutionType({}, true).then(res => {
        self.loading = false
        self.tableData = res.data || []
      }).catch(error => {
        self.loading = false
      })
    },
    addClick () {
      this.dialogTitle = '新增分类'
      this.editFormData = {
        typeName: '',
        parentId: 0,
        orderNum: 1,
        remark: ''
      }
      this.dialogVisible = true
    },
    addChildClick (item) {
      this.dialogTitle = '新增分类'
      this.editFormData = {
        typeName: '',
        parentId: item.id,
        orderNum: 1,
        remark: ''
      }
      this.dialogVisible = true
    },
    editClick (item) {
      this.dialogTitle = '编辑分类'
      this.editFormData = JSON.parse(JSON.stringify(item))
      this.dialogVisible = true
    },
    deleteClick (row) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该分类吗?', '提示', {
        type: 'warning'
      }).then(() => {
        CropSolutionApi.deleteCropSolutionType({
          id: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getSolutionTypeList()
        })
      })
    },
    dialogFormVisible () {
      this.editFormData = {
        typeName: '',
        parentId: 0,
        orderNum: 1,
        remark: ''
      }
    },
    submit () {
      let self = this
      self.$refs.form.validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(self.editFormData))
          if (self.editFormData.id) {
            CropSolutionApi.editCropSolutionType(param, true).then(data => {
              self.loading = false
              self.$message({
                message: '修改成功',
                type: 'success'
              })
              self.getSolutionTypeList()
              self.dialogVisible = false
            }).catch(error => {
              self.loading = false
            })
          } else {
            CropSolutionApi.addCropSolutionType(param, true).then(data => {
              self.loading = false
              self.$message({
                message: '添加成功',
                type: 'success'
              })
              self.getSolutionTypeList()
              self.dialogVisible = false
            }).catch(error => {
              self.loading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/crop/solution/type/list.vue